import { useContext } from 'react'

import { SelectContext } from '../../../../context'

export function useSelectContext() {
  const context = useContext(SelectContext)

  return context
}
